// extracted by mini-css-extract-plugin
export default {"ma-accordion":"MaAccordion_ma-accordion__9C3hN"};